import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { JumpToComponent } from '../../shared/components/jump-to/jump-to.component';
import { Section1Component } from './section1/section1.component';
import { GlobalHeroComponent } from '../../shared/components/global-hero/global-hero.component';
import { CtaBottomComponent } from '../../shared/components/cta-bottom/cta-bottom.component';
import { appPaths } from '../../app.paths';
import { QuizComponent } from './quiz/quiz.component';
import { ScrollSpyService } from '../../shared/services/scroll-spy.service';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { ReviewBarComponent } from '../../shared/components/review-bar/review-bar.component';

@Component({
  selector: '[whats-your-td1-risk]',
  imports: [
    CommonModule,
    GlobalHeroComponent,
    JumpToComponent,
    Section1Component,
    QuizComponent,
    CtaBottomComponent,
    ReviewBarComponent,
  ],
  templateUrl: './whats-your-td1-risk.component.html',
  styleUrl: './whats-your-td1-risk.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhatsYourTd1RiskComponent implements OnInit, OnDestroy {
  scrollSpyService = inject(ScrollSpyService);

  activeSection$!: Observable<string | null>;

  heroData = {
    backgroundImageDesktop: 'hero-whats-your-td1-risk',
    titleText: 'KNOW YOUR TYPE&nbsp;1 DIABETES',
    bodyTextDesktopWidth: '',
    titleColorText: 'RISK',
    bodyText:
      'Your type 1 diabetes risk might be higher <br class="d-none d-lg-inline" />than you think.',
    sillHouetteImage: 'hero-sillhouette-whats-your-td1-risk',
    sillhouetteAlt: 'Cassie Bailey and her son outdoors',
    sillhouette: {
      mobile: {
        width: 292,
        top: 48,
        left: 49,
      },
      tablet: {
        width: 210,
        top: 10,
        left: 129,
      },
      desktop: {
        width: 395,
        height: 322,
        top: 18,
        left: 242,
      },
    },
  };

  ctaBottomData = {
    icon: 'antibodies',
    alt: 'A magnifying glass looking at autoantibodies',
    title:
      'If you think you or your loved one might be at risk for type 1 diabetes, talk to your doctor about screening.',
    button: {
      buttonLabel: 'Learn how to screen',
      buttonUrl: appPaths.HOWTOSCREEN + '/',
      openInNewTab: false,
      buttonIcon: 'right-icon',
    },
  };

  ctaBottomData2 = {
    icon: 'doctors',
    alt: 'A care team',
    title: `Are you an HCP looking for<br class="d-none d-lg-inline" /> information for your patients? <br class="d-none d-lg-inline" />We've got resources for you!`,
    text: '',
    button: {
      buttonLabel: 'Discover HCP Resources',
      buttonUrl: appPaths.RESOURCE + '/',
      openInNewTab: false,
      buttonIcon: 'right-icon',
    },
  };

  jumpToData = [
    {
      buttonLabel: 'Understand risk factors',
      buttonUrl: '/know-your-risk',
      buttonFragment: 'understand-risk-factors',
    },
    {
      buttonLabel: 'Take the Type 1 Risk Quiz',
      buttonUrl: '/know-your-risk',
      buttonFragment: 'risk-quiz',
    },
  ];

  ngOnInit(): void {
    const sectionIds = this.jumpToData.map((item) => item.buttonFragment);
    this.scrollSpyService.initObserver(sectionIds);

    this.activeSection$ = this.scrollSpyService.activeSection$;
  }

  ngOnDestroy(): void {
    this.scrollSpyService.disconnectObserver();
  }
}
